import { BrandLoader } from '@uturn/ui-kit';
import { useTranslation } from 'react-i18next';

export function LoadingSpan() {
	const { t } = useTranslation();

	return <span>{t('general.loading', 'Loading...')}</span>;
}

export function LoadingSpinnerWithLogo() {
	const { t } = useTranslation();

	return (
		<div className="text-secondary-500 flex h-screen w-screen flex-col items-center justify-center gap-3 text-3xl font-bold">
			<BrandLoader className="h-20 w-auto" />
			<div>{t('general.loading', 'Loading...')}</div>
		</div>
	);
}
